import { render, staticRenderFns } from "./TeamTransferDialog.vue?vue&type=template&id=59a0c249"
import script from "./TeamTransferDialog.vue?vue&type=script&lang=js"
export * from "./TeamTransferDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports